import {appURLS} from "appRoot/app.constants";
import NetworkConnectionService from 'external-services/network-connection-service/index';
import LocalStorageService from "external-services/local-storage-service/localStorage.service";
import {LoginRoutes, NgLocalStorageKey} from "app/app.types";
import AdminService from "external-services/diary-admin-service/admin.service";
import { Roles } from 'external-services/manager-service/types';
import { ToastType } from "shared-types/index"
import LoginActions from "app/actions/login.actions";
import OAuth2Service from 'external-services/oauth-login/OAuth2.service';
const NS = 'AuthService'; // jshint ignore:line

export default function AuthService(
  $rootScope, $http, $state, ToastActions
) {
  "ngInject";

  let token = false;
  let SELF;

  var service = {
    authStr: '',
    getBearerToken: () => 'Bearer ' + getToken(), // needed for IAuthService
    login,
    setToken,
    getToken,
    checkAuth,
    checkAuthSync,
    logout,
    updateToken,
    forgotPassword,
    getAuthorizationCode,
    openAdminLogin,
    roleCheckLogout,
    showServerBusyMessage
  };

  const MAX_RETRIES = 4;

  return service;

  function login(username, password, code, inheritedResolve, inheritedReject, retryCount = 0) {
    if (!SELF) {
      SELF = this;
    }

    let postData;
    if (code) {
      postData = 'grant_type=authorization_code&code=' + code + '&client_id=BookItApp';
    } else {
      postData = 'grant_type=password&username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password) + '&client_id=BookItApp';
    }

    const url = appURLS.API + '/oauth';

    setIsLegacyLogin(true);

    return new Promise((resolve, reject) => {

      const _resolve = inheritedResolve || resolve;
      const _reject = inheritedReject || reject;

      const conf = {
        cache: false,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        timeout: 3500
      };

      $http.post(url, postData, conf).then(res => {

        const data = res.data;
        setToken(data.access_token);
        checkAuth(data.access_token);

        SELF.user = data; // @todo: determine what this is used for and remove if not needed. Severity: low
        _resolve(data);
        $rootScope.$broadcast('login');
      }, response => { // error response

        // if login creds are wrong, we don't want to retry
        const badLoginCreds = response && response.data && response.data.error === 'invalid_grant';

        if (!badLoginCreds && retryCount < MAX_RETRIES && NetworkConnectionService.isNavigatorOnline()) {
          const wait = 2000;
          console.log(NS, `API failed on url ${url}`, response, `retrying: ${retryCount+1} / ${MAX_RETRIES} in ${wait/1000} seconds`);
          setTimeout(() => {
            login(username, password, code, false, _resolve, _reject, retryCount+1);
          }, wait);
          return;
        }
        console.log(NS, 'error', response, NetworkConnectionService.isNavigatorOnline());
        _reject(response);
      });
    });
  }

  async function checkAuth(passToken) {
    if (window.config.enableOAuth2 && OAuth2Service.getIsEnableOAuth()) {
      return OAuth2Service.checkForUserAuth();
    } else {
      var token = (passToken) ? passToken : getToken();
      if (!token || token === 'null') {
        return false;
      } else {
        service.authStr = 'Bearer ' + token;
        return true;
      }
    }
  }
  function checkAuthSync(passToken) {
    if (window.config.enableOAuth2 && OAuth2Service.getIsEnableOAuth()) {
      return OAuth2Service.checkForUserAuthSync();
    } else {
      var token = (passToken) ? passToken : getToken();
      if (!token || token === 'null') {
        return false;
      } else {
        service.authStr = 'Bearer ' + token;
        return true;
      }
    }
  }
  function updateToken(newToken) {
    token = newToken
    service.authStr = 'Bearer ' + newToken;
    this.setToken(newToken);
  }
  function getToken() {
    if (window.config.enableOAuth2 && OAuth2Service.getIsEnableOAuth()) {
      return OAuth2Service.getOAuth2AccessToken();
    }
    if (token) {
      return token;
    }

    token = LocalStorageService.get(NgLocalStorageKey.token);
    return token;
  }

  function setToken(value) {
    LocalStorageService.set(NgLocalStorageKey.token, value);
  }

  function setIsLegacyLogin(value) {
    LocalStorageService.set(NgLocalStorageKey.isLegacyLogin, value);
  }


  /**
   * Request a password reset for a specific email
   */
  function forgotPassword(email) {
    return $http.post(appURLS.API + '/forgotpassword', {
      email: email
    });
  }

  function logout(dontRedirect) {
    token = null;
    service.authStr = '';

    LocalStorageService.remove(NgLocalStorageKey.token);
    // other local storage values get cleared in adminService

    // $rootScope.$broadcast('logout');
    LoginActions.logout();
    if (!dontRedirect) {
      $state.go('logout');
    }
  }

  function getAuthorizationCode() {
    const apiUrl = appURLS.API;
    return $http.get(apiUrl + '/me/authorization', {
      headers: {
        'Authorization': service.authStr
      }
    }).then(function (repsonse) {
      return repsonse.data.code;
    });
  }

  function showDismissableAuthErrorToast() {
    
    ToastActions.showToastFullOptions({
      msg: `Authorisation error. You may dismiss thie message and continue, <br/>but if you experience any more authorisation issues, you should <br/>log out and log back in again. `,
      type: ToastType.warning,
      isImportant: false,
      hideDismissBtn: false
    });

    setTimeout(() => ToastActions.clearToast(), 10000);
  }


  function roleCheckLogout(venueId) {
    // temporary fix: instead of forcing logout when they get 401 error, show a dismissable toast, so they can still use the app
    showDismissableAuthErrorToast();
    return;

    const account = AdminService.getAccount();
    const secondsUntilRedirect = 15;
    let countdown = secondsUntilRedirect;
    const adminRoles = [
      Roles.VenueAdmin,
      Roles.Support,
      Roles.BookItAdmin,
      Roles.BookItStaff,
      Roles.AccountAdmin
    ]
    const isAdminUser = account.roles.some(({name}) => {
      return adminRoles.includes(name)
    });
    const sendToastMsg = () => {
      ToastActions.showToast(`Unauthorised.
      <br>You have been logged out as you have an expired token.
      <br>As you have an 'Admin' role you will be redirected to the Admin login screen.
      <br><span style="font-size:1.8rem">Redirecting in ${countdown} seconds.</span>`, ToastType.error, true, true);
    };

    this.logout(isAdminUser);
    if (isAdminUser) {

      const countdownFunc = () => {
        setTimeout(() => {
          if (countdown > 0) {
            countdown--;
            sendToastMsg();
            countdownFunc();
          } else {
            this.openAdminLogin();
          }
        }, 1000);
      };

      sendToastMsg();
      countdownFunc();
    } else {
      ToastActions.showToast(`Unauthorised. You have been logged out as you have an expired token. Please login.`, ToastType.error, false, true);
      setTimeout(() => ToastActions.clearToast(), 10000);
    }
    logRoleCheckLogoutTrace(account, venueId);
  }

  function showServerBusyMessage() {
    ToastActions.showToast("Server busy. <br>You have been switched to offline mode temporarily, <br>but should be back to normal again soon.", ToastType.warning);
    setTimeout(() => ToastActions.clearToast(), 10000);
  }

  function openAdminLogin(inNewTab) {
    window.open(`/#/${LoginRoutes.adminLogin}`, inNewTab ? '_blank' : '_self');
  }


  /**
   * Logging to try and figure out why accountId is missing from getVenues call, which causes user to be
   * logged out.
   */
  function logRoleCheckLogoutTrace(account, venueId) {
    try {
      const traceError = new Error('Trace to roleCheckLogout');
      console.log(NS, 'roleCheckLogout called', account);
      if (traceError.stack) {
        const stackWithoutMessage = traceError.stack
          .split('\n')
          .slice(1)
          .join('\n');
        console.log(NS, 'Upstream call stack prior to roleCheckLogout:\n' + stackWithoutMessage);

        const accountInfo = account ? `{ account id: ${account.id}, roles: ${account.roles.map(({name}) => name).join(", ")} }. ` : '';
        this.serverLoggingDbEvents(
          venueId || "(No Venue Id)",
          `roleCheckLogout`,
          AdminServiceLog.WARNLOG,
          `${accountInfo}Stack trace: ${stackWithoutMessage}`
        );
      }
    } catch {
      // ignore logging failures
    }
  }
}
